<template>
   <md-layout  md-gutter md-column class='exp_choice' v-if="isProfileFilled" md-vertical-align="start" style="flex:0 1 auto">
   <md-layout style="flex: 0 1 0%; margin: 50px 0;">
   <h2 class="">CHOOSE THE TYPE OF EXPERIMENT</h2>
   </md-layout>
   <md-layout>
    <md-layout md-align="center"  class="l_choice">
       <img src='../assets/like_icons.png' class="choice_icon" style="width: 245px; height: 115px;"/>
       <p class="choice_text md-body-1">
       
       In this experiment you'll have to put likes\dislikes based on your perception of the molecule. 
       You can have multiple criterions but try just to give the overall impression of the molecule you see. <br/> <br/>
       You'll have 5 seconds on each molecule
       
       </p>
       <md-button class="choice_button like_button" @click="gotoExperimentLike">
         LIKE OR DISIKE
       </md-button>
      
    </md-layout>
    
    <md-layout md-align="center"  class="l_choice">
       <img src='../assets/human_gan_icons.png' class="choice_icon" style="width: 245px; height: 115px;"/>
       <p class="choice_text md-body-1">
       In this experiment you'll have to distinguish human and GAN designed molecules. 
       Make your decision wisely as it's not that easy to tell one from another. 
       Try to beat AI and guess as much as possible. <br/> <br/> 
       You'll have 5 seconds on each molecule   
       </p>
       <md-button class="choice_button hg_button" @click="gotoExperimentGan">
         HUMAN OR GAN
       </md-button>
       
    </md-layout>
    
    <md-layout md-align="center"  class="l_choice">
      <img src='../assets/emotiv_icon.png' class="choice_icon" style="width: 95px; height: 115px; "/> 
        <p class="choice_text md-body-1">
       Use EMOTIV device to record emotions that each molecule evokes in you.
       We'll record your EEG, facial expression and will track your glance.<br/> <br/> <br/>
       You'll have 5 seconds on each molecule 
       </p>
       <md-button class="choice_button emotiv_button" @click="gotoExperimentCortex">
         EMOTIVE EEG
       </md-button>
    </md-layout>
  
  </md-layout>
  </md-layout>
  
  <md-layout md-align="center" class="exp_choice" v-else> <!-- Show this if Profile is not fully filled -->
    <h2>PLEASE FILL IN <router-link to="profile">PROFILE</router-link> FORM TO START THE EXPERIMENT</h2>
  </md-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'experiment-choice',
  props: [],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  computed: {
	  ...mapGetters({
  		isProfileFilled: 'getProfileFilled',
  	    }),
	},
  methods: {
	  gotoExperimentLike: function(){
		  this.$router.push({name: 'preexperiment',  params: { 'experiment_type': 0 }});
      },
	  gotoExperimentGan: function(){
		  this.$router.push({name: 'preexperiment',  params: { 'experiment_type': 1 }});
      },
	  gotoExperimentCortex: function(){
		  this.$router.push({name: 'preexperiment',  params: { 'experiment_type': 2 }});
      }
    
    }
}

</script>

<style>
.exp-card {
    width: 100%;
    margin: 10px;
}
.exp_choice {
    margin: 50px 0 100px 0;  
}
.exp_choice h2 {
    color:#eb8d00;
    text-align: center;
    margin: 0 auto; 
    font-size: 2vw;
    line-height: 1.23;
}
.l_choice {
    margin: 30px 30px;
}
.choice_icon{
    
    
    
}
.choice_text {
    border-left: 1px solid black;
    padding-left: 5%;
    font-size: .9vw;
    font-weight: 100;
}
.choice_button {
    color: #fff;
    width: 100%;
    font-size: 2vw;
    padding: 10px;
    box-shadow: 0 5px 30px rgba(0,0,0,.2), 0 4px 10px rgba(0,0,0,.14), 0 6px 2px -4px rgba(0,0,0,.12);
    
}
.like_button {  
    background-color: #6faa43;
}
.hg_button {
    background-color: #58b1df;
}
.emotiv_button{
    background-color: #a455d7;
}
</style>


// WEBPACK FOOTER //
// ExperimentChoice.vue?8a91d5f0